module.exports = __webpack_public_path__ + "media/images/flags/64/Tonga-02d16c66ee3626db2d9798c41b9dd500.png";